import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';

export class CompareObjectService {
    /*
    * @method constructor - Setup base values used
    */
    constructor(){
        this.updateValue = 1;
    }
    
    /*
    * @method setUpdateValue - sets the value to be assignes to status to signify update
    */
    setUpdateValue(value){
        this.updateValue = value;
    }
    
    /*
    * @method shallowCompareHasChanged
    * @param obj1 original array
    * @param obj2 working copy/ modified array
    * @param isUpdate optional To add status attribute and set it to 1
    */
    shallowCompareHasChanged(obj1, obj2){
        if(isEqual(obj1, obj2)){
            return false;
        }else{
            return true;
        }
    }
    
    /**
    * @method checkTypeOfArray - Checks whether the object is type of Array 
    * @param value
    * @returns boolean
    **/
    checkTypeOfArray(value){
        return Object.prototype.toString.call(value) == '[object Array]';
    }
    
    /**
    * @method checkTypeOfArray
    * @param value
    * @returns boolean
    **/
    checkTypeOfObject(value){
        return typeof value === 'object';
    }
    
    /*
    * @method deepCompareArrayHasChanged
    * @param obj1 original array
    * @param obj2 working copy/ modified array
    * @param isUpdate optional To add status attribute and set it to 1
    * @returns boolean/array
    */
    deepCompareArrayHasChanged(obj1, obj2, isUpdate){
        var changes, i, item, checkTypeOfObject = this.checkTypeOfObject;
        if(isEqual(obj1, obj2)){
            return false;
        };
        changes = [];
        i = 0;
        forEach(obj2, (value) => {
//            console.log("In deepCompareArray \t"+JSON.stringify(obj1[i])+"\n"+JSON.stringify(value)+"\n");
            if (obj1[i] && !isEqual(value, obj1[i])) {
                
              if(isUpdate && checkTypeOfObject(value)){
//                  console.log("In deepCompareArray \t"+JSON.stringify(obj1[i])+"\n"+JSON.stringify(value)+"\n");
                  this.deepCompareObjectHasChanged(obj1[i], value, isUpdate)
                  if(value.status == -1){
                      value.status = this.updateValue;
                  }
              }
              changes.push(item);
            }
            i++;
        });
        if(!isUpdate)
        {
            return changes; 
        }
        else
        {
            return true;
        }
    }
    
    /*
    * @method shallowCompareObjectHasChanged
    * @param obj1 original obj
    * @param obj2 working copy/ modified obj
    * @param isUpdate optional To add status attribute and set it to 1
    */
    shallowCompareObjectHasChanged(obj1, obj2, isUpdate){
        if (isEqual(obj1, obj2)) {
            if(isUpdate){
                obj2.status = -1;
            };
            return false;
        }
        
        if(!isUpdate)
        {
            return changes; 
        }else{
            obj2.status = this.updateValue;
            return true;
        }
    }

    /*
    * @method deepCompareObjectHasChanged
    * @param obj1 original obj
    * @param obj2 working copy/ modified obj
    * @param isUpdate optional To add status attribute and set it to 1
    */
    deepCompareObjectHasChanged(obj1, obj2, isUpdate){
        var changes; 
//        console.log(this.updateValue);
        if (isEqual(obj1, obj2)) {
            if(isUpdate){
                obj2.status = -1;
            };
            return false;
        }
        changes = [];
        forEach(obj2, (value, key) => {
            var obj = {};
            if(value && this.checkTypeOfArray(value)){
                if(isUpdate){
                    this.deepCompareArrayHasChanged(obj1[key], obj2[key], isUpdate);
//                    console.log(JSON.stringify(obj1[key])+ "\n" + JSON.stringify(obj2[key]));
                }else{
                    changes.concat(this.deepCompareArrayHasChanged(obj1[key], obj2[key]));
                }
            }else if(value && this.checkTypeOfObject(value)){
                if(isUpdate){
                    this.deepCompareObjectHasChanged(obj1[key], obj2[key], isUpdate);
                }else{
                    changes.concat(this.deepCompareObjectHasChanged(obj1[key], obj2[key]));
                }
            }
            if(!isUpdate && !isEqual(value, obj1[key])){
                obj[key] = value;
                changes.push(obj);
            }
        });
        if(isUpdate){
            if(obj2.status == -1){
                obj2.status = this.updateValue;
            }
            return true;
        }else{
            return changes;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/compare-object/compare-object.service.js